export const SET_CATEGORY = "setCategory"
export const CATEGORY_RESET = "categoryReset"
export const CATEGORY_RESET_STATE = "categoryResetState"
export const SET_CATEGORIES = "setCategories"
export const CATEGORIES_RESET_STATE = "categoriesReset"
export const RESET_STATE = "resetState"
export const SET_CATEGORIES_SEARCH = "setCategoriesSearch"
export const SET_CATEGORY_PAGINATION = "setBenefitPagination"
export const SET_CATEGORY_ACTIVE = "setCategoryActive"
  